module.exports = __webpack_public_path__ + "static/media/add.13e09146.svg";